import * as moment from 'moment';


export const VEHICLE_CHANGE_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface VehicleChangeContextState {
  phone: string;
  vehicleType: string;
  doorsNumber: number;
  doorsNumberTypes: number[];
  power: string;
  powerTypes: string[];
  version: string;
  manualVersion: string;
  transmissionType: string;
  transmissionTypes: string[];
  fuelType: VehicleFuelType;
  vehicleBrand: VehicleChangeBrandType;
  vehicleModel: VehicleChangeModelType;
  licenseDataType: number;
  plateNumber: string;
  frameNumber: string;
  displacement: string;
  displacementTypes: string[];
  fisrtRegistrationDate: moment.Moment;
  changeDate: moment.Moment;
  isSusceptible: boolean;
  contactSchedule: string;
  confirmVersion: boolean;
  vehicleSelected: VehicleData;
  vehicles: VehicleVersion[];
  vehiclesCatalogue: VehicleVersion[];
  vehiclesCatalogueFiltered: VehicleVersion[];
  fuelTypes: VehicleFuelType[];
  brands: VehicleChangeBrandType[];
  models: VehicleChangeModelType[];
  requestId:string;
}

export interface VehicleVersion {
  carPlate: string;
  chassisNumber: string;
  baseVehicleCode: string;
  baseVehicleCode7: string;
  codeTypeRela: string;
  vehicleCode: string;
  categoryName: string;
  typeVehicleCode: string;
  vehicleTypeName: string;
  comDesigVehicle: string;
  mapfreRefCode: string;
  brandCode: string;
  brandName: string;
  modelCode: string;
  modelName: string;
  versionCode: string;
  versionName: string;
  doorNumber: string | number;
  numPotCvDin: string;
  displacementNumCm3: string;
  gearshiftName: string;
  fuelCode: string;
  fuelName: string;
  commercialStartDate: string;
  commercialFinishDate: string;
  amountNumberPvp: string;
}

export interface VehicleChangeRequestResponse {
  code: string,
  description: string,
  dataId: string
}

export type VehicleFuelType = {
  fuelCode: string;
  fuelName: string;
  measureUnitCode?: string;
  measureUnitName?: string;
}

export type VehicleChangeBrandType = {
  code: string;
  name: string;
  fivaCode: string;
}

export type VehicleChangeModelType = {
  code: string;
  name: string;
}

export interface VehicleData extends VehicleVersion {
  id: string;
  name: string;
  label: string;
  labelMotorcycle: string;
  brand: string;
  model: string;
  power: string;
  version: string;
  doorNumber: number;
  fuelType: string;
  transmissionType: string;
  displacement: string;
  startAt: string;
}

export enum VehicleChangeServicePath {
  BASE_PATH = '/carChange',
  MODELS = 'models',
  BRANDS = 'brands',
  VEHICLES = 'vehicles',
  FUELS = 'fuels',
}

export enum VehicleChangeLoadingId {
  VEHICLE_BRANDS = 'get-vehicle-brands',
  VEHICLE_LIST = 'get-vehicle-list',
  VEHICLE_FUEL_TYPES = 'get-vehicle-fuel-types',
  VEHICLE_MODELS = 'get-vehicle-models',
  VEHICLE_VERSION = 'get-vehicle-version',
  REGISTRATION_DATE = 'registration-date',
  SEND_REQUEST = 'send-request',
}

export enum VehicleChangeRountingPath {
  CHANGE_DATE = 'change-date',
  CONTACT_INFO = 'contact-info',
  CONFIRM_DATA = 'confirm-data',
  DOORS_NUMBER = 'doors-number',
  ERROR = 'error',
  FIRST_REGISTRATION = 'first-registration',
  FUEL_TYPE = 'fuel-type',
  LICENSE_PLATE_DATA = 'license-plate-data',
  MODULE_PATH = 'vehicle-change/',
  NEW_VEHICLE = 'new-vehicle',
  SUCCESS = 'success',
  TRANSMISSION_TYPE = 'transmission-type',
  VEHICLE_BRAND = 'vehicle-brand',
  VEHICLE_DISPLACEMENT = 'displacement',
  VEHICLE_MODEL = 'vehicle-model',
  VEHICLE_POWER = 'vehicle-power',
  VEHICLE_VERSION_CATALOGUE = 'vehicle-version-catalogue',
  VEHICLE_VERSION = 'vehicle-version'
}

export const NotMyVehicleID = 'not-my-vehicle'

export const VehicleChangeNewTypeOptions = {
  CAR: '00000009',
  MOTORBIKE: '00000008'
};

export const VehicleChangeLicenseDataOptions = {
  PLATE: 1,
  FRAME: 2
};

export const VehicleChangeDoorsNumberOptions = {
  THREE_OR_LESS: 1,
  MORE_THAN_TREE: 2
};


